import { render, staticRenderFns } from "./productManagement.vue?vue&type=template&id=372c569c&"
import script from "./productManagement.vue?vue&type=script&lang=js&"
export * from "./productManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports